<template>
        <card>
            <template slot="header">
                <h3 class="card-title">Leave Management</h3>
            </template>
            <div class="row">
                <div class="col-md-8">
                    <nav class="row">
                        <ol class="breadcrumb arr-right bg-breadcrum">
                            <li class="breadcrumb-item">
                                <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                            </li>
                            <li class="breadcrumb-item active">Leave & Absences Record</li>
                            <li class="breadcrumb-item">
                                <router-link to="leavecredits">Employee Leave Credits</router-link>
                            </li>
                        </ol>
                    </nav>
                </div>
                <div class="col-md-4">
                    <router-link :to="'requestleave'" class="btn  btn-primary float-right" v-b-tooltip.hover title="You can encode here manually based on request"><i class="fa fa-plus"></i> Encode Leave Manually</router-link>
                </div>
            </div>
            <hr style="margin-top:-10px" />
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-3">
                        <p><i class="fa fa-search"></i> Search Employee</p>
                        <input type="test" v-model="search" class="form-control" placeholder="Search...">
                    </div>
                    <div class="col-md-2">
                        <p><i class="fa fa-filter"></i> Filter By Year</p>
                        <select v-model="filter_by_year" @change="getYear" class="form-control" required>
                            <option v-for="year in years(2019)">{{ year }}</option>
                        </select>
                 </div>
                    <div class="col-md-1">
                        <div class="form-group">
                            <p><i class="fa fa-sort-numeric-asc"></i>&nbsp;Display</p>
                            <select v-model="page_limit" class="form-control" required>
                                <option value="">Default</option>
                                <option value="2">2</option>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="500">500</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <p><i class="fa fa-filter"></i>&nbsp;Filter by Status:</p>
                            <select v-model="filter_by_status" class="form-control" required>
                                <option value="">Default</option>
                                <option value="pending">pending</option>
                                <option value="approved">approved</option>
                                <option value="rejected">rejected</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <p><i class="fa fa-filter"></i>&nbsp;Leave Type:</p>
                            <select v-model="filter_by_type" class="form-control" required>
                                <option value="">Default</option>
                                <option value="Vacation">Vacation Leave</option>
                                <option value="Medical/Sick">Medical/Sick Leave</option>
                                <option value="Emergency">Emergency Leave</option>
                                <option value="Maternity">Maternity Leave</option>
                                <option value="Paternity">Paternity Leave</option>
                                <option value="Bereavement">Bereavement Leave</option>
                                <option value="Offset">Offset</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <p><i class="fa fa-sort-amount-asc"></i>&nbsp;Order by </p>
                            <select v-model="order_by" class="form-control" required>
                                <option value="">Default</option>
                                <option value="1">ASC</option>
                                <option value="-1">DESC</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <!-- PAGINATION -->
            <b-pagination
            v-model="curentPage"
            :total-rows="items.length"
            :per-page="perPage"
             aria-controls="my-table"
             align="right"
             first-text="First"
             prev-text="Prev"
             next-text="Next"
             last-text="Last"
            ></b-pagination>
            <!-- END PAGINATION -->
            <hr>
            <div class="table-responsive ">
                <table class="table table-striped table-hover " v-loading="loading" id="my-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th width="450">Employee Name</th>
                            <th width="250">Date Filled</th>
                            <th width="100">Days</th>
                            <!-- <th width="610"><i class="fa fa-sticky-note-o"></i>Reason</th> -->
                            <th width="650">Period</th>
                            <th width="200">Leave Type</th>
                            <th width="220">Remarks</th>
                            <th width="170">Status</th>
                            <th width="350"></th>
                            <th width="30"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item,index in computedLeave">
                            <template v-if="item === 'no data found'">
                                <td colspan="100%">
                                    <h4>  <i class="fa fa-database"></i> Empty Records ...</h4></td>
                            </template>
                            <template v-else>
                                <td>{{index + 1}}</td>
                                <td>
                                    <template v-if="item.full_name.length < 25">{{item.full_name | capitalize}}</template>
                                    <template v-if="item.full_name.length >= 25">{{ item.full_name.substring(0,25)+"..." | capitalize}}</template>
                                </td>
                                <td><i class="fa fa-calendar"></i>&nbsp;{{item.date_filled}}</td>
    
                                <td><span class="badge badge-pill badge-info">{{item.no_of_days}} </span> </td>
                                <!-- <td>
                                    <template v-if="item.reason.length < 30">{{ item.reason }}</template>
                                    <template v-if="item.reason.length >= 30">{{ item.reason .substring(0,30)+"..." }}</template>
                                </td> -->
                                <td><i class="fa fa-calendar"></i>&nbsp;{{item.start_date}} &nbsp;&nbsp;<b>To</b> &nbsp;&nbsp;<i class="fa fa-calendar-check-o"></i>&nbsp;{{item.end_date}}</td>
                                <td>{{item.leave_type}}</td>
                                <td><i class="fa fa-dot-circle-o"></i>&nbsp;{{item.remarks}}</td>
                                <td>
                                    <span v-if="item.status === 'pending'">
                                    <button class="pending">Pending</button>
                                    </span>
                                    <span v-else-if="item.status === 'approved'"> 
                                    <button class="approved-leave" @click="selected_employee(item)" v-b-modal.leave-update><i class="fa fa-location-arrow"></i>Approved</button>
                                    </span>
                                    <span v-else-if="item.status === 'rejected'"> 
                                    <button class="rejected">Rejected</button>
                                    </span>
                                </td>
                                <td>
                                    <span v-if="(item.user_id != 0) &&  (item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.status === 'approved')">
                                      <router-link :to="{name: 'view-leave', params: { id: item.id }}" class="r-link" ><i class="fa fa-eye"></i>View Details</router-link>
                                    </span>
                                    <span v-else-if="(item.user_id == 0) && (item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.status === 'approved')">
                                      <font color="red">No ESS Account</font>
                                    </span>
                                    <span v-if="(item.user_id != 0) && (item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.status === 'pending')">
                                       <router-link :to="{name: 'leave-approval', params: { id: item.id }}" class="r-link"><i class="fa fa-mail-forward"></i>Review Request</router-link>&nbsp;&nbsp;<span class="badge badge-danger">New</span>
                                    </span>
                                    <span v-else-if="(item.user_id == 0) && (item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.status === 'pending')">
                                       <font color="red">No ESS Account</font>
                                  </span>
                                </td>
                                <td>
                                   <span v-if="(item.tl_status === 'approved') && (item.asm_status === 'approved') && (item.ceo_status === 'approved') && (item.status === 'pending')">
                                      <button class="btn btn-danger btn-xs btn-circle" @click = "deleteItem(item.id, index)" v-b-tooltip.hover title="Remove Leave Request"><i class="fa fa-times"></i></button>
                                   </span>
                                </td>
                            </template>
                        </tr>
                    </tbody>
                </table>
            </div>
               <!-- MODAL FOR UPDATE RECORD  -->
               <b-modal id="leave-update" ref="hide-leave"  size="l"   hide-footer>
                 <hr style="margin-top:-10px" />
                  <button class="btn btn-info" @click="cancel_leave" v-model="selected_item.id"><i class="fa fa-remove"></i>&nbsp;Cancel Leave Request</button>
                  <router-link :to="{name: 'update-leave', params: { id: selected_item.id }}" class="btn btn-info"><i class="fa fa-pencil"></i>&nbsp;Update Leave Request</router-link>
                <hr style="margin-top:20px" />
                <p><i>This action you can cancel a employee leave request or update leave application form.</i></p>
             </b-modal>
            <!-- PAGINATION NATIVE WAY -->
            <div class="row">
              <div class="col-md-6">
                  <p style="color:#9a9a9a">Page {{curentPage}} out of {{total_item}} records</p>
              </div>
              <div class="col-md-6">
                <b-pagination
                    v-model="curentPage"
                    :total-rows="items.length"
                    :per-page="perPage"
                    aria-controls="my-table"
                    align="right"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                ></b-pagination>
              </div>
           </div>
           <!-- END PAGINATION -->
           <template v-if="display_indicator === 1">
                <center>
                   <br/><br/>
                   <img  src="/static/img/warning.png"  width="225" height="190">
                   <h1>You've lost your network connection</h1>
                   <h3>Check your wireless settings, or your network cable, and reload the page.</h3>
                   <br/><br/>
                </center>
             </template>
        </card>
    </template>
    <script>
    /* eslint-disable */
    import Card from 'src/components/UIComponents/Cards/Card.vue'
    export default {
      components: {
        Card
      },
    
      data() {
        return {
          items: [],
          leave_status: "",
          search: "",
          order_by: "",
          filter_by_status: "",
          filter_by_type: "",
          filter_by_year:"",
          //SORTING
          page_limit: "",
          start_page: 1,
          loading: true,
          //PAGINATION
          perPage: 200,
          curentPage:1,
          selected_item:'',
          //Indicator
          display_indicator: '',
        };
      },
    
      mounted: function() {
        this.get_employees_leave();
      },
    
      methods: {

         deleteItem(id, index) {

            /* USING SWEET ALERT */
            this.$swal({
                title: 'Are you sure?',
                text: 'You can\'t revert your action',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes Delete it!',
                cancelButtonText: 'No, Keep it!',
                showCloseButton: false,
                showLoaderOnConfirm: true
                })
                .then((isConfirm) => {
                if (isConfirm === true) {
                    axios.delete('api/leaveabsences/delete/' + id)
                        .then(response => {
                        this.get_employees_leave(); // reloader 
                        this.$swal('Deleted', 'You successfully deleted this file', 'success')
                    })
                    .catch(response => {
                        //alert("error");
                        console.log(response);
                        this.$swal('Error Code', 'Review your code', 'error')
                    });
                }
                });
            },  

        getYear(){
            if(this.filter_by_year == ''){
                this.get_employees_leave()
            }else{
                axios.get('api/leavemanagement/' + this.filter_by_year)
                .then(response => {
                    this.items = response.data;
                })
                .catch(error => {
                    console.log(error.response)
                });
            } 
       },

        selected_employee(item){
            this.selected_item = item
        },  
        
        cancel_leave(){
            this.$swal({
                    title: "Are you sure?",
                    text: "Do you want to cancel this leave request.",
                    type: "warning",
                    showCancelButton: true,
                    showCloseButton: false
                }).then(isConfirm => {
                    if (isConfirm === true) {
                        axios.post('api/leave/approval/hr/' + this.selected_item.id,
                                    { status: "rejected"})
                           .then(resp => {
                                if(resp.data.response == 'success'){
                                        this.$swal({
                                           type: 'success',
                                           title: 'Cancelled',
                                           text: resp.data.message,
                                           showConfirmButton: true,
                                           timer: 2000
                                        })
                                        this.get_employees_leave()
                                        this.$refs['hide-leave'].hide();

                                }else if(resp.data.response == 'error'){
                                    this.$swal({
                                           type: 'error',
                                           title: 'Oops',
                                           text: resp.data.message,
                                           showConfirmButton: true,
                                        })
                                    }
                                console.log(resp.data)
                         })
                        .catch(error => {
                            console.log(error)
                        });
                    }
                })
        },
        
        //GET EMPLOYEES LEAVE
        get_employees_leave() {
          axios
            .get("api/leavemanagement")
            .then(response => {
              this.items = response.data;
              this.loading = false;
              this.display_indicator = 2;
            })
            .catch(error => {
              console.log(error.response);
              this.display_indicator = 1;
             
            });
        }
      },
      computed: {
       
        offset() {  return (this.start_page - 1) * this.page_limit; },
        limit() { return this.offset + this.page_limit; },   
        total_item(){ return this.items.length }, 

        computedLeave() {
          let filtered = this.items;
          // USE IN PAGINATION 
          let start = (this.curentPage-1) * this.perPage
          let end = this.curentPage * this.perPage
          filtered = filtered.slice(start, end)

          if (filtered.length > 0) {
            // SEARCH BY EMPLOYEE FULLNAME
            if (this.search) {
              filtered = filtered.filter(
                item => item.full_name.toLowerCase().indexOf(this.search) > -1
              );
              return filtered;
            }
            // SORTING NUMBER OF DISPLAY
            if (this.page_limit) {
              filtered = filtered.slice(this.offset, this.limit);
              return filtered;
            }
            // FILTER BY STATUS
            if (this.filter_by_status) {
              filtered = filtered.filter(
                item =>
                  item.status.toLowerCase() === this.filter_by_status.toLowerCase()
              );
              return filtered;
            }
            // FILTER BY TYPE
            if (this.filter_by_type) {
              filtered = filtered.filter(
                item =>
                  item.leave_type.toLowerCase() === this.filter_by_type.toLowerCase()
              );
              return filtered;
            }
            // ORDER BY ASC AND DESC COMBOBOX
            if (this.order_by) {
              filtered = filtered
                .slice(0)
                .sort((a, b) =>
                  a.full_name < b.full_name ? this.order_by : -this.order_by
                );
              return filtered;
            }
          }
          
          return filtered
        }
      },
    };
    </script>
    
     
        


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-leave-management/todo-leave-management.vue